'use client';

import React from 'react';
import { useColors } from '../theme/ThemeProvider';

/**
 * Switch — iOS-style toggle.
 *
 * The native-feeling on/off control for settings rows. Lime when on,
 * subtle surface when off; the knob slides with the iOS spring curve.
 * Controlled: pass `on` + `onChange`.
 */
export interface SwitchProps {
  on: boolean;
  onChange: (on: boolean) => void;
  'aria-label'?: string;
}

export function Switch({ on, onChange, 'aria-label': ariaLabel }: SwitchProps) {
  const c = useColors();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      aria-label={ariaLabel}
      onClick={() => onChange(!on)}
      style={{
        width: 51,
        height: 31,
        borderRadius: 999,
        border: 'none',
        padding: 2,
        cursor: 'pointer',
        background: on ? c.accent : c.surfaceAlt,
        display: 'flex',
        justifyContent: on ? 'flex-end' : 'flex-start',
        alignItems: 'center',
        transition: 'background 240ms cubic-bezier(0.32, 0.72, 0, 1)',
      }}
    >
      <span
        style={{
          width: 27,
          height: 27,
          borderRadius: 999,
          background: '#FFFFFF',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.25)',
        }}
      />
    </button>
  );
}
